<template>
<div class="video-preview-control">
  <div class="video-preview-control-main">
    <div class="circle">
    <div class="arrow arrow-up" @mousedown="ptzControl('up')"></div>
    <div class="arrow arrow-down" @mousedown="ptzControl('down')"></div>
    <div class="arrow arrow-left" @mousedown="ptzControl('left')"></div>
    <div class="arrow arrow-right" @mousedown="ptzControl('right')"></div>
    <div class="camera camera-up" @mousedown="ptzControl('zoomout')">+</div>
    <div class="camera camera-down" @mousedown="ptzControl('zoomin')">-</div>
    </div>
  </div>
  <div class="slider">
    <span>慢</span>
    <el-slider class="speed" v-model="speed" :min="1" :max="10"></el-slider>
    <span>快</span>
  </div>
</div>
</template>
<script>
import qiniuyunApi from "@/api/qny_video";
export default {
  data () {
    return {
      speed: 5,
      t1: null,
      direction:null//当前命令
    }
  },
  methods: {
    ptzControl (action) {
      const that = this
      that.t1 = null
      const data = {
        cmd: action,
        speed: that.speed  // 调节速度 (1-10, 默认位5)
      }
      qiniuyunApi.videoControl(data).then((res) => {
        if (res.code === 200) {
          that.direction = action
          that.t1 = setTimeout(() => {
            if (action!='stop') {
              this.ptzControl('stop')
            }
          }, 500)
        }
      });
    }
  },
  mounted () {
    this.ptzControl('stop')
  }
}
</script>
<style scoped>
.video-preview-control {
  width: 180px;
}
.video-preview-control-main {
  position: relative;
  padding-top: 100%;
  margin-top: 10px;
}
.circle {
  position: absolute;
  top: 15px;
  left: 15px;
  right: 15px;
  bottom: 15px;
  border-radius: 50%;
  border: 40px solid #3f475a;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
  background: #1b1b1b;
}
.arrow {
  position: absolute;
  cursor: pointer;
  user-select: none;
}
.arrow:before {
  content: '';
  display: inline-block;
  position: absolute;
  border: 10px solid #ccdaeb;
  z-index: 1;
} 
.arrow:hover:before {
  border: 10px solid #fff;
}
.arrow:active:before {
  border: 10px solid #666;
}
.arrow:after {
  content: '';
  display: inline-block;
  position: absolute;
  border: 10px solid transparent;
  z-index: 0;
}
.arrow-up {
  top: -40px;
  left: 0;
  width: 70px;
  height: 40px;
}
.arrow-up:before {
  top: 5px;
  left: 25px;
  border-top-color: transparent !important;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
}
.arrow-up:after {
  top: 7px;
  left: 27px;
  border-bottom-color: rgba(0, 0, 0, 0.3);
}
.arrow-left {
  top: 0;
  left: -40px;
  width: 40px;
  height: 70px;
}
.arrow-left:before {
  top: 25px;
  left: 5px;
  border-top-color: transparent !important;
  border-left-color: transparent !important;
  border-bottom-color: transparent !important;
}
.arrow-left:after {
  top: 27px;
  left: 7px;
  border-right-color: rgba(0, 0, 0, 0.3);
}
.arrow-right {
  top: 0;
  left: 70px;
  width: 40px;
  height: 70px;
}
.arrow-right:before {
  top: 25px;
  left: 15px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
}
.arrow-right:after {
  top: 27px;
  left: 17px;
  border-left-color: rgba(0, 0, 0, 0.3);
}
.arrow-down {
  top: 70px;
  left: 0;
  width: 72px;
  height: 40px;
}
.arrow-down:before {
  top: 15px;
  left: 25px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
}
.arrow-down:after {
  top: 17px;
  left: 27px;
  border-top-color: rgba(0, 0, 0, 0.3);
}
.camera {
  position: absolute;
  background: #cfdff1;
  color: #1b1b1b;
  width: 48px;
  height: 24px;
  line-height: 20px;
  text-align: center;
  left: 11px;
  box-sizing: border-box;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
}
.camera-up {
  top: 11px;
  border-top-left-radius: 48px;
  border-top-right-radius: 48px;
  border-bottom: 1px solid #1b1b1b;
}
.camera-down {
  bottom: 11px;
  border-bottom-left-radius: 48px;
  border-bottom-right-radius: 48px;
  border-top: 1px solid #1b1b1b;
}
.slider {
  overflow: hidden;
}
.slider > * {
  float: left;
}
.slider > span {
  display: inline-block;
  width: 30px;
  text-align: center;
  height: 36px;
  line-height: 36px;
  vertical-align: top;
}
.slider .speed {
  width: 120px;
}
</style>
